import { Component, Input } from '@angular/core';

/**
 * Generic empty/no-results state, matching the design mockup's hint/no-results pattern
 * (d1HomeHintStyle/noResultsStyle). No feature page has a consistent empty-state today - this
 * is a net-new reusable pattern, not a port of existing markup.
 */
@Component({
    selector: 'app-empty-state',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent {
    @Input() icon?: string;
    @Input() title: string;
    @Input() description?: string;
}
